import { Text, makeStyles, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '24px',
    height: '24px',
    paddingLeft: tokens.spacingHorizontalXS,
    paddingRight: tokens.spacingHorizontalXS,
    borderRadius: tokens.borderRadiusCircular,
    backgroundColor: tokens.colorNeutralBackground5,
    color: tokens.colorNeutralForeground1,
    fontSize: tokens.fontSizeBase200,
    lineHeight: tokens.lineHeightBase200,
    fontWeight: tokens.fontWeightSemibold,
  },
  // Plain em-dash rendering when count is unknown — keep the same color as
  // other metadata fallbacks (Owner, Date modified) for visual consistency.
  fallback: {
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase300,
  },
});

export interface CountBadgeProps {
  /** Numeric count to display. Pass null/undefined when the count is unknown. */
  count: number | null | undefined;
  ariaLabel?: string;
}

/**
 * Dark circular pill displaying a numeric count. Used for things like the
 * "Workflows" column in the Apps table. When `count` is null/undefined,
 * renders an em-dash so we don't surface a misleading "0".
 */
export const CountBadge = ({ count, ariaLabel }: CountBadgeProps) => {
  const styles = useStyles();
  if (count === null || count === undefined) {
    return <Text className={styles.fallback} aria-label={ariaLabel ?? 'Unknown'}>—</Text>;
  }
  return (
    <span className={styles.root} aria-label={ariaLabel}>
      {count}
    </span>
  );
};
